import { DateFilterTypesEnum, UserDashboardService } from "@propertelligent/client-api";
import { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
} from "recharts";
import { UserLoginData } from "../components/common/charts/Enums";
import apiHelper from "../utils/apiHelper";
import DateHelper from "../utils/DateHelper";
import TimeRangeDropdown from "../newComponents/time-range-filter/time-range-dropdown";
import UtilHelper from "../utils/UtilHelper";
import { useCurrencySymbol } from "../hooks/useCurrencySymbol";
import SimpleSpinner from "../components/loader";
import { GetImages } from "../utils/GetImages";
import EmptyState from "../newComponents/emptystate";

const IncomeExpense = ({ loadingStates, setLoadingStates, incomeExpense_monthValue, setincomeExpense_MonthValue }) => {
  const currencySymbol = useCurrencySymbol();
  const orgId = sessionStorage.getItem(UserLoginData.organization_id);
  const [expenseData, setExpenseData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const timeRanges = ["Last 12 Month", "Last 6 Month", "Last 3 Month", "This Month"]
  const labelToEnum = {
    "This Month": DateFilterTypesEnum.MonthToDate,
    "Last 3 Month": DateFilterTypesEnum.Last3Months,
    "Last 6 Month": DateFilterTypesEnum.Last6Months,
    "Last 12 Month": DateFilterTypesEnum.Last12Months,
  };
  const getOverDuePayment = () => {
    setLoading(true);
    const dateFilterId = typeof incomeExpense_monthValue === "string"
      ? labelToEnum[incomeExpense_monthValue] ?? DateFilterTypesEnum.Last3Months
      : incomeExpense_monthValue;

    const payload = {
      dateFilterTypeId: dateFilterId,
      clientDate: DateHelper.getClientDate(),
    };
    apiHelper(UserDashboardService.putApiUserDashboardIncomeExpense, { showNotification: false }, orgId, payload)
      .then((res) => {
        if (res?.data?.success) {
          // const convertedData = res?.data?.success?.map(convertToObject);
          // setExpenseData(convertedData);
          const convertedData = res?.data?.success
            ?.map(convertToObject)
            .sort((a, b) => {
              const [monthA, yearA] = a.name.split(' ');
              const [monthB, yearB] = b.name.split(' ');

              // Convert short month name to number
              const monthNum = (month: string) =>
                new Date(Date.parse(month + " 1, 2000")).getMonth();

              const diff = parseInt(yearA) - parseInt(yearB);
              return diff !== 0 ? diff : monthNum(monthA) - monthNum(monthB);
            });

          setExpenseData(convertedData);

        }
        setLoading(false);
      }).catch((err) => { setLoading(false); })
  }

  useEffect(() => {
    getOverDuePayment()
  }, [incomeExpense_monthValue])

  const convertToObject = (obj) => {
    return ({
      name: `${new Date(obj.year, obj.month - 1).toLocaleString("default", {
        month: "short",
      })} ${obj.year.toString().slice(2)}`,
      Income: obj.income,
      Expense: obj.expense,
      formatted: obj.formatted,
    });
  }

  const CustomTooltip = ({
    active,
    payload,
  }: {
    active?: boolean;
    payload?: any[];
  }) => {
    if (active && payload && payload.length) {
      const data1 = payload[1];
      const data2 = payload[0];

      return (
        <div className="toolTipContainer" id="incomeExpenseTooltip">
          <div>
            <p className="sub_text black fw-bold mb-2">{`${data1.payload.name}`}</p>
          </div>
          <div className="d-flex gap-4 align-items-center vacancyDataContainer ">
            <div>
              <p className="sub_text grey_subtext1 mb-1">Expense</p>
              <p className="normal_text black">{`${currencySymbol}${data1.payload?.formatted?.Expense || 0}`}</p>
            </div>
            <div>
              <p className="sub_text grey_subtext1 mb-1">Income</p>
              <p className="normal_text black">{`${currencySymbol}${data2.payload?.formatted?.Income || 0}`}</p>
            </div>
          </div>
        </div>
      );
    }

    return null;
  };

  const isDataEmpty = (data) => {
    return data.every((item) => item.Expense === 0 && item.Income === 0);
  };

  return (
    <div>
      <div className="overviewContainerMain">
        <div className="overviewContainerRightSide">
          <div className="overviewContainerRightSideTopComponent"
          >
            <p className="sub_heading black">Income vs Expense</p>
            <TimeRangeDropdown
              timeRanges={timeRanges}
              defaultTimeRange="Last 12 Month"
              onTimeRangeChange={(monthvalue) => { setincomeExpense_MonthValue(monthvalue) }}
            />
            {/* <div className="overviewButtons">
              <Form.Select
                className="sub_text  grey_subtext1"
                aria-label="Default select Service Sub Type"
                required
                onChange={(e) => {
                  setMonths(e.target.value);
                }}
                value={months}
              >
                <option value={DateFilterTypesEnum.MonthToDate}>Last month </option>
                <option value={DateFilterTypesEnum.Last3Months}>Last 3 months </option>
                <option value={DateFilterTypesEnum.Last6Months}>Last 6 months </option>
                <option value={DateFilterTypesEnum.Last12Months}>Last 12 months </option>
              </Form.Select>
            </div> */}
          </div>
          <div
            className="d-flex justify-content-center firstChartStyles p-3"
            style={{ width: "100%", height: 250 }}
          >
            {loading ? (
              <div className="d-flex align-items-center h-100">
                <SimpleSpinner myClassName="Icon50" />
              </div>
            ) : expenseData.length > 0 && !isDataEmpty(expenseData) ? (

              <ResponsiveContainer width={"100%"} height={"100%"}>
                <BarChart
                  width={500}
                  height={300}
                  data={expenseData}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 24,
                  }}
                  barCategoryGap="10%"
                  barGap={0}
                >
                  {/* <XAxis
                    className="sub_text grey_subtext1"
                    dataKey="name"
                    tick={{ textAnchor: "middle" }}
                    interval={0}
                  > */}
                  <XAxis
                    className="sub_text grey_subtext1"
                    dataKey="name"
                    tick={{ fill: "var(--grey-subtext1)", fontSize: 12 }}
                    interval={0}
                    tickFormatter={(value) => {

                      const isFullDate = value.includes(",");
                      return isFullDate ? value : value.split(" ")[0];
                    }}
                  >
                    <Label
                      className="sub_text grey_subtext1"
                      value="Months"
                      position="bottom"
                      offset={-5}
                      style={{ fill: "var(--grey-subtext1)" }}
                    />
                  </XAxis>

                  <YAxis
                    className="sub_text grey_subtext1"
                    tick={{ fill: "var(--grey-subtext1)", fontSize: 12 }}
                    tickFormatter={(value) => UtilHelper.formatCurrency(value, true, currencySymbol)}
                  >
                    <Label
                      value="Amounts"
                      position="left"
                      angle={-90}
                      offset={15}
                      style={{ textAnchor: "middle", fill: "var(--grey-subtext1)" }}
                      className="sub_text grey_subtext1"
                    />
                  </YAxis>

                  <Tooltip
                    position={{ x: tooltipPosition.x, y: tooltipPosition.y }}
                    content={<CustomTooltip />}
                    cursor={{ fill: "var(--chart-cursor)" }}
                  />
                  <Legend
                    className="sub_text grey_subtext1"
                    order="reverse"
                    iconType="circle"
                    iconSize={8}
                    wrapperStyle={{
                      position: "relative",
                      display: "flex",
                      justifyContent: "center",
                      paddingLeft: 60,
                      paddingBottom: 20,
                      fontFamily: '"Inter", sans-serif',
                      fontSize: 12,
                      fontWeight: 400,
                    }}
                  />
                  <Bar dataKey="Expense" fill="#057A55" maxBarSize={24} />
                  <Bar dataKey="Income" fill="#D61F69" maxBarSize={24} />
                </BarChart>
              </ResponsiveContainer>

            ) : (
              <EmptyState
                icon={GetImages.emptyStateData}
                className="w-100"
                isBorder={false}
                heading="No Data found"
                isButton={false}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IncomeExpense;

